import { can, PortalPermissions } from "../../../../../../config/permissions";
import {
  AnticipationResultData,
  IReceivable,
  LiveTableProps,
  ModalResponse,
  SimulationReceivableForAnticipation,
  SimulationRequest,
} from "../../types";
import React, { useEffect, useState } from "react";
import { formatDateView } from "../../../../../adiqEdi/detalhesEdi/utils";
import LoadingOverlay from "../../../../../../components/LoadingOverlay";
import { Button, TableContainer } from "../../../../styles";
import Table, { TableColumn } from "../../../../../../components/Table";
import {
  formatAcquirer,
  formatChannel,
  formatMoney,
  formatSaleDateView,
} from "../../../../../transacoesErepasses/painelDeRecebiveis/utils";
import { Checkbox } from "antd";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import { Modal } from "../simulateModal";
import AnticipationService from "../../service/AnticipationService";
import { toast } from "react-toastify";
import { AnticipationResultModal } from "../simulationResultModal/AnticipationResultModal";

export const LiveTable: React.FC<LiveTableProps> = ({
  data,
  currentPage,
  pageSize,
  onPageChange,
  onPageSizeChange,
  onSaveChanges,
  anticipationFees,
  merchantId,
}) => {
  const formattedDate = (date: string) => formatDateView(date);
  const anticipationService = new AnticipationService();
  const [isLoading, setIsLoading] = useState(false);
  const [receivables, setReceivables] = useState<IReceivable[]>([]);
  const [anticipatedReceivables, setAnticipatedReceivables] = useState<
    IReceivable[]
  >([]);
  const [newReceiveDate, setNewReceiveDate] = useState<string>("");
  const [anticipationFee, setAnticipationFee] = useState<number | null>(null);
  const [isModalShowing, setIsModalShowing] = useState(false);
  const [totalValue, setTotalValue] = useState<number>(0);
  const [totalGrossValue, setTotalGrossValue] = useState<number>(0);
  const [isShowingResult, setIsShowingResult] = useState(false);
  const [resultData, setResultData] = useState<SimulationRequest | null>(null);

  const handleModalConfirmation = async (modalData: ModalResponse) => {
    setIsModalShowing(false);

    if (modalData.confirmation) {
      const anticipationFee = modalData.anticipationFee as number;
      const newReceiveDate = modalData.newReceiveDate as string;
      const rebuyFee = modalData.rebuyFee as number;
      const otherBillingsFee = modalData.otherBillingsFee as number;
      const exemptFee = modalData.exemptFee as boolean;

      if(exemptFee) {
        anticipationFees.adValorem = 0,
        anticipationFees.additionalIof = 0,
        anticipationFees.dailyIof = 0,
        anticipationFees.operationFee = 0
      }

      // Atualiza os receivíveis com os dados vindos do modal
      const updatedReceivables: SimulationReceivableForAnticipation[] =
        anticipatedReceivables.map(
          ({
            acquirerNsu,
            authorizationNumber,
            merchant,
            currentParcel,
            paymentDateDate,
            liquidValue,
            receiveDate,
            value,
          }) => ({
            nsu: acquirerNsu,
            authorization: authorizationNumber,
            merchantId: merchant,
            currentParcel,
            paymentDate: paymentDateDate,
            liquidValue,
            receiveDate,
            value,
          })
        );

      const document = anticipatedReceivables[0].document;
      const businessName = anticipatedReceivables[0].businessName;

      const simulateAnticipation: SimulationRequest = {
        anticipationFee: anticipationFee,
        newReceiveDate: newReceiveDate,
        adValoremFee: anticipationFees.adValorem,
        dailyIofFee: anticipationFees.dailyIof,
        additionalIofFee: anticipationFees.additionalIof,
        tariffFee: anticipationFees.operationFee,
        rebuyFee: rebuyFee || 0,
        othersBillingsFee: otherBillingsFee || 0,
        totalLiquidValue: totalValue,
        totalGrossValue: totalGrossValue,
        countAnticipatedTransactions: anticipatedReceivables.length,
        merchantId: merchantId || "",
        businessName: businessName || "",
        document: document || "",
        receivables: updatedReceivables,
      };


      setIsLoading(true);
      try {
        setResultData(simulateAnticipation);

        setIsShowingResult(true);
      } catch (error) {
        console.error("Erro ao buscar nos dados: ", error);
      } finally {
        setIsLoading(false);
      }

      // Chama o serviço com os dados atualizados
      // setIsLoading(true);
      // try {
      //   const result = null;
      //   if (result.status === 200) {
      //     toast.success(result.data.message);

      //     if (onSaveChanges) onSaveChanges(true);
      //   }
      // } catch (error) {
      //   toast.error(error);
      //   console.log(error);
      // } finally {
      //   setIsLoading(false);
      // }
    }
  };

  useEffect(() => {
    const anticipated = receivables.filter(
      (receivable) => receivable.anticipationDate != null
    );
    setAnticipatedReceivables(anticipated);
  }, [receivables]);

  const handleSaveClick = () => {
    const anticipatedReceivablesAux = receivables.filter(
      (receivable) => receivable.anticipationDate != null
    );

    const totalLiquid = anticipatedReceivablesAux.reduce(
      (sum, receivable) => sum + (receivable.liquidValue || 0),
      0
    );

    const totalGross = anticipatedReceivablesAux.reduce(
      (sum, receivable) => sum + (receivable.value || 0),
      0
    );

    setTotalGrossValue(totalGross);
    setTotalValue(totalLiquid);
    setAnticipatedReceivables(anticipatedReceivablesAux);
    setIsModalShowing(true);
  };

  const changeReceivableCheck = (
    event: CheckboxChangeEvent,
    receivable: IReceivable
  ) => {
    const isChecked = event.target.checked;

    // Cria nova lista com objeto atualizado
    const updatedReceivables = receivables.map((r) => {
      if (r.id === receivable.id) {
        return {
          ...r,
          anticipationDate: isChecked
            ? new Date().toISOString().split("T")[0]
            : null, // Desconsidera hora
        };
      }
      return r;
    });

    setReceivables(updatedReceivables);
  };

const removeFlagged = () => {
  setReceivables(prev =>
    prev.filter(item => item.anticipationDate == null)
  );
  setAnticipatedReceivables([]);
};

  const changeAllReceivableChecks = (event: CheckboxChangeEvent) => {
    const isChecked = event.target.checked;

    const updatedReceivables = receivables.map((receivable) => ({
      ...receivable,
      anticipationDate: isChecked
        ? new Date().toISOString().split("T")[0]
        : null,
    }));

    setReceivables(updatedReceivables);
  };

  useEffect(() => {
    setReceivables(data.records);
  }, [data.records]);

  const allChecked =
    receivables.length > 0 && receivables.every((r) => !!r.anticipationDate);
  const someChecked = receivables.some((r) => !!r.anticipationDate);

  return (
    <div>
      <LoadingOverlay show={isLoading} relative />
      <TableContainer>
        <div style={{ marginBottom: 16, textAlign: "right" }}>
          {can(PortalPermissions.cobrancas.antecipacaoPontual.solicitar) && (
            <Button
              type="primary"
              onClick={handleSaveClick}
              disabled={anticipatedReceivables.length === 0}
            >
              Simular
            </Button>
          )}
          {anticipatedReceivables.length > 0 && (
            <span style={{ marginLeft: 8 }}>
              {anticipatedReceivables.length} antecipações pendentes
            </span>
          )}
        </div>

        <Table
          dataSource={receivables}
          pagination={{
            defaultPageSize: pageSize,
            defaultCurrent: currentPage,
            current: currentPage,
            onShowSizeChange: (_, size) => {
              onPageSizeChange(size);
            },
            total: data.count,
            onChange: (pageNum) => onPageChange(pageNum),
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} de ${total} recebíveis`,
          }}
        >
          <TableColumn
            title="Data de recebimento"
            dataIndex="receiveDate"
            key="receiveDate"
            render={formattedDate}
          />
          <TableColumn
            title="Data/Hora da venda"
            dataIndex="paymentDate"
            key="paymentDate"
            render={formatSaleDateView}
          />
          <TableColumn
            title="Codigo do lojista"
            dataIndex="merchant"
            key="merchant"
          />
          <TableColumn
            title="Empresa"
            dataIndex="businessName"
            key="businessName"
          />
          <TableColumn title="NSU" dataIndex="acquirerNsu" key="acquirerNsu" />
          <TableColumn
            title="Canal do pagamento"
            render={formatChannel}
            dataIndex="captureChannel"
            key="captureChannel"
          />
          <TableColumn
            title="Tipo Pagamento"
            dataIndex="productName"
            key="productName"
          />
          <TableColumn
            title="Total Parcelas"
            dataIndex="parcels"
            key="parcels"
          />
          <TableColumn
            title="Parcela Atual"
            dataIndex="currentParcel"
            key="currentParcel"
          />
          <TableColumn title="Bandeira" dataIndex="brand" key="brand" />
          <TableColumn
            title="Valor Líquido"
            render={formatMoney}
            dataIndex="liquidValue"
            key="liquidValue"
          />
          <TableColumn
            title="Adquirente"
            render={formatAcquirer}
            dataIndex="acquirer"
            key="acquirer"
          />
          <TableColumn
            title={
              <div>
                Antecipado
                <Checkbox
                  style={{ paddingLeft: "8px" }}
                  name="anticipated"
                  onChange={changeAllReceivableChecks}
                  indeterminate={!allChecked && someChecked}
                  checked={allChecked}
                ></Checkbox>
              </div>
            }
            render={(text: any, receivable: any) => (
              <Checkbox
                checked={!!receivable.anticipationDate}
                name="advanced"
                onChange={(event) => changeReceivableCheck(event, receivable)}
              />
            )}
          />
        </Table>
      </TableContainer>
      <Modal
        isShowing={isModalShowing}
        onConfirmation={handleModalConfirmation}
        data={anticipatedReceivables.length}
        totalLiquidValue={totalValue}
      />
      <AnticipationResultModal
        isShowingResult={isShowingResult}
        onClose={() => setIsShowingResult(false)}
        data={resultData}
        onConfirmed={removeFlagged}
      />
    </div>
  );
};
